import { useParams } from "react-router-dom";
import ExtendCompany from "./ExtendCompany";
import { Box } from "@mui/material";
export const ShowCompany = () => {
  const { id } = useParams();

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendCompany row={{ id, onUpdate: () => {}, onDelete: () => {} }} />
    </Box>
  );
};
